import React from 'react';
import { FaBuilding, FaUsers } from 'react-icons/fa';
import RichText from '../ui/RichText';
import '../../css/common/RoomReservationCard.css';

const RoomReservationCard = ({ facility }) => {
  return (
    <div className="room-reservation-card">
      <div className="room-reservation-card-header">
        <div className="room-reservation-card-icon">
          <FaBuilding />
        </div>
        <h3 className="room-reservation-card-title">{facility.title}</h3>
      </div>
      
      <RichText value={facility.description} className="room-reservation-card-description" />
      
      <div className="room-reservation-card-capacity">
        <FaUsers /> {facility.capacity}
      </div>
      
      <div className="room-reservation-card-features">
        <h4>Features:</h4>
        <ul>
          {facility.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RoomReservationCard; 